import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import GroupsIcon from "@mui/icons-material/Groups";
import PsychologyIcon from "@mui/icons-material/Psychology";
import BoltIcon from "@mui/icons-material/Bolt";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

interface CardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const AchieveCard: React.FC<CardProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: "18px",
        height: "165px",
        background: "white",
        border: "1px solid rgba(15,99,165,0.15)",
        boxShadow: "0 8px 24px rgba(15,99,165,0.06)",

        transitionProperty: "all",
        transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
        transitionDuration: "150ms",

        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 20px 40px rgba(15,99,165,0.15)",
          borderColor: "#0f63a5",
        },
      }}
    >
      {/* Icon */}
     <Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 2,
    mb: 1,
  }}
>
  <Box
    sx={{
      width: 60,
      height: 60,
      borderRadius: "16px",
      background: "linear-gradient(135deg, #0f63a5, #1c88e5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      boxShadow: "0 8px 20px rgba(15,99,165,0.25)",
      flexShrink: 0,
      
    }}
  >
    {icon}
  </Box>

  <Typography
    variant="h6"
    fontWeight={700}
    sx={{
      textAlign: "start",
      fontSize: { xs: "1.05rem", md: "1.1rem" }
    }}
  >
    {title}
  </Typography>
</Box>

      <Typography
        variant="body2"
        sx={{
          color: "#555",
          lineHeight: 1.8,
          textAlign:"start"
        }}
      >
        {description}
      </Typography>
    </Paper>
  );
};


const AchieveSection: React.FC = () => {
  return (
    <Box
      sx={{
        py:{xs:2,md:"auto"},
        background: `
          radial-gradient(circle at 10% 20%, rgba(15,99,165,0.08), transparent 40%),
          radial-gradient(circle at 90% 80%, rgba(15,99,165,0.06), transparent 40%),
          linear-gradient(180deg, #f8fbff 0%, #eef5fc 100%)
        `,
        borderTop: "2px solid rgba(15,99,165,0.15)",
        height:{xs:"auto",md:"100vh"},
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 10 } }}>
        {/* Section Header */}
        <Box textAlign="center" mb={5}>
          <Typography
            variant="h2"
            fontWeight={700}
            gutterBottom
          >
            What You'll Achieve
          </Typography>

          {/* <Typography
            variant="body1"
            sx={{ color: "#0f63a5", fontWeight: 500 }}
          >
            Real <b>Results</b> . Measurable <b>Impact</b> .
          </Typography> */}
        </Box>

        {/* Cards Grid */}
        <Grid container 
         rowSpacing={4}
            columnSpacing={4}>
          <Grid item xs={12} md={4}>
            <AchieveCard
              icon={<TrendingUpIcon style={{fontSize:"40px"}} />}
              title="Increase Sales Revenue"
              description="Move from inconsistent wins to structured, repeatable conversions backed by a clear sales framework."
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <AchieveCard
              icon={<AttachMoneyIcon style={{fontSize:"40px"}}/>}
              title="Strengthen Cash Flow & Margins"
              description="Position your product or service with authority so pricing becomes a decision, not a negotiation."
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <AchieveCard
              icon={<GroupsIcon style={{fontSize:"40px"}}/>}
              title="Build High Value Clientele"
              description="Learn how to handle premium buyers with clarity, control, and long-term relationship thinking."
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <AchieveCard
              icon={<PsychologyIcon style={{fontSize:"40px"}}/>}
              title="Master Sales Psychology"
              description="Understand how decision-makers think at higher ticket sizes and adapt conversations accordingly."
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <AchieveCard
              icon={<BoltIcon style={{fontSize:"40px"}}/>}
              title="Eliminate Revenue Leaks"
              description="Identify where deals slow down or break and install systems that prevent loss of momentum."
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <AchieveCard
              icon={<WorkspacePremiumIcon style={{fontSize:"40px"}}/>}
              title="Operate With Authority"
              description="Develop the confidence, communication discipline, and positioning required to lead in competitive markets."
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AchieveSection;
